import React from 'react';
import {Modal, Table, ControlLabel} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {personFullName} from '../../../../services/Api';


const AnnuityPaymentDetailModal = ( props )=>{
    const { annuityPayment, onHide, urlCreator, type } = props;
    const person = annuityPayment.membership? annuityPayment.membership.person : props.person;

    return (
        <Modal
            show={true}
            onHide={ onHide }>

            <Modal.Header closeButton>
                <Modal.Title>Pago de anualidad de {type==='ihs'?'IHS':'membresía'}</Modal.Title>
            </Modal.Header>

            <Modal.Body >
                <div className='AnnuityPaymentDetail'>
                    <Table>
                        <tbody>
                        <tr>
                            <td>Persona:</td>
                            <td>{personFullName(person)}</td>
                        </tr>
                        <tr>
                            <td>Número de Miembro:</td>
                            <td>{person.membership?person.membership.id:""}</td>
                        </tr>
                        <tr>
                            <td>Fecha de pago:</td>
                            <td>{moment(annuityPayment.paymentDate).format('DD/MM/YYYY')}</td>
                        </tr>
                        <tr>
                            <td>Anualidad:</td>
                            <td>{annuityPayment.year}</td>
                        </tr>
                        </tbody>
                    </Table>
                    <ControlLabel>Archivos:</ControlLabel>
                    {annuityPayment.files.length?
                        annuityPayment.files.map( (file)=>
                            <p key={file.id}><a href={urlCreator(file.id)} target='_blank'>{file.originalName}</a></p>
                        )
                        :
                        <p>No se encontraron archivos.</p>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AnnuityPaymentDetailModal;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/AnnuityPaymentDetailModal/index.js